$(() => {
    $('html').removeClass('no-js').addClass('js');
    $('body').addClass('page-ready');
});
